/* eslint-disable import/no-cycle */
import React, { useEffect, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import isEmpty from 'lodash/isEmpty';
import _once from 'lodash/once';
import classNames from 'classnames';
import { CancelApplicationModal } from 'aurora-components';
import messages from 'aurora-translations';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { CleverTapGenericServiceScreenEvent } from 'aurora-utils/cleverTap.eventhelper';
import { Typography } from '@material-ui/core';
import history from 'aurora-utils/history';
import styles from './styles';
import PrimaryLessorInformation from '../../containers/Routes/Service/Lease/WorkflowPanels/PrimaryLessorInformation';
import LeaseUnitDetails from '../../containers/Routes/Service/Lease/WorkflowPanels/LeaseUnitDetails';
import ADGMImage from '../ADGMImage';

function ADGMWorkflow(props) {
  const {
    classes,
    intl,
    loading,
    workflow,
    currentStep,
    handleNext,
    handleBack,
    handleFormChange,
    panelComponents,
    cancelApplication,
    onwaniAddress,
    applicationNumber,
    workflowId,
    isMultipleUnits,
    isRegistration,
    isPermission,
    ...otherProps
  } = props;

  const [dialogueOpen, setDialogueOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [callCancelApi, setCallCancelApi] = useState(false);

  const isLeaseApp = useMemo(() => workflowId === 'LEASE_REGISTRATION', [workflowId]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const leaseSteps = useMemo(() => {
    const sortedSteps = workflow?.steps
      ?.filter(item => item.groupKey)
      ?.sort((step1, step2) => (step1?.squence < step2?.squence ? -1 : 1));
    return isMultipleUnits ? sortedSteps : sortedSteps?.filter(step => step?.key !== 'PREMISE_DETAIL');
  }, [workflow, isMultipleUnits]);
  const CleverTapMemoizedCall = useCallback(
    _once((otherPropsArg, steps) => {
      const stepName = steps?.find(step => step.squence === currentStep + 1)?.key;
      CleverTapGenericServiceScreenEvent({
        screenName: `screen_${otherPropsArg?.applicationType}_${stepName}_view`,
        applicationStatus: otherPropsArg?.applicationStatus,
        applicationId: otherPropsArg?.applicationId,
        applicationNumber,
        applicationType: otherPropsArg?.applicationType,
        stepName,
      });
    }),
    [currentStep],
  );

  useEffect(() => {
    if (otherProps.applicationId && workflow?.steps) {
      window.scrollTo(0, 0);
      CleverTapMemoizedCall(otherProps, workflow?.steps);
    }
  }, [currentStep, otherProps.applicationId, workflow?.steps]);

  const { steps = [], panels = [], attributes = [] } = workflow || {};

  const isLastStep = () => currentStep + 1 === workflow?.steps?.filter(step => step.groupKey).length;

  const isLastLeaseStep = useMemo(() => {
    return currentStep + 1 === leaseSteps?.length;
  }, [currentStep, leaseSteps]);

  const handleDialogue = () => {
    if (currentStep === 0 && otherProps?.applicationStatus === 'DRAFT') {
      setDialogueOpen(true);
      return;
    }
    handleBack && handleBack();
  };

  const getWorkflowDropdownValue = useCallback(
    (name, value) => {
      const attribute = attributes
        .find(attr => attr.name === name)
        .values.find(val => val.valueId === value.toString());
      return {
        value: attribute?.id,
        valueId: attribute?.valueId,
        label: messages[attribute?.valueName]?.id && intl.formatMessage({ ...messages[attribute?.valueName] }),
      };
    },
    [attributes],
  );

  const getFieldMask = (mask = '') => Array.from(mask).map(item => (item === '#' ? /\d/ : item));

  // const customTitle = 'Application Steps';

  return (
    <>
      <Grid container spacing={3} className={classes.workflowContainer}>
        {!isPermission ? (
          <>
            <div className={classes.StepperContainer}>
              <Grid container>
                <Grid item xs={9} md={9} style={{ order: isMobile ? 2 : 1 }}>
                  <div className={classes.StepperInnerContainer}>
                    {/* { isMultipleUnits ?
                      <div className={classes.StepperHeader}>
                        <Typography variant='h5' className={classes.StepperTitle}>
                          {customTitle || keyEmptyCheck('application_steps')}
                        </Typography>
                        {loading !== true &&
                          (otherProps?.applicationType === 'LEASE_REGISTRATION' ||
                            otherProps?.applicationType === 'LEASE_RENEWAL' ||
                            otherProps?.applicationType === 'LEASE_AMENDMENT') &&
                          otherProps?.applicationStatus === 'DRAFT' && (
                            <ADGMImage
                              name='trash_red.svg'
                              alt='trash'
                              onClick={() => {
                                setDialogueOpen(true);
                                setCallCancelApi(true);
                              }}
                            />
                          )}
                      </div>
                      :""} */}
                    <Stepper
                      nonLinear
                      activeStep={currentStep}
                      orientation='horizontal'
                      connector={<></>}
                      classes={{
                        vertical: classNames(classes.stepperopnerList, {
                          [classes.stepperopnerListMulti]: isMultipleUnits === true,
                        }),
                      }}
                    >
                      {(isLeaseApp ? leaseSteps : steps)
                        ?.filter(item => item.groupKey)
                        ?.map((step, index) => (
                          <Step
                            key={step.key}
                            className={classNames(
                              isMultipleUnits ? classes.RootStepMultiple : classes.RootStep,
                              steps?.length <= 3 && classes.flex1,
                            )}
                          >
                            <StepButton
                              onClick={() => {
                                if (index === currentStep) return;
                                index < currentStep ? handleBack(index) : handleNext();
                              }}
                              // completed={currentStep > index}
                              active={index === currentStep}
                              classes={{
                                root: classNames({
                                  [classes.stepButtonComplete]: currentStep > index,
                                  [classes.ACTIVE]: currentStep === index,
                                }),
                              }}
                            >
                              <StepLabel
                                classes={{
                                  root: classes.MuiStepLabelRoot,
                                  label: classes.label,
                                  active: classes.labellistActive,
                                  iconContainer: classes.MuiStepLabeliconContainer,
                                }}
                                // StepIconProps={{
                                //   classes: {
                                //     root: classes.listingiconRoot,
                                //     text: classes.completed,
                                //     active: classes.labellistActive,
                                //   },
                                // }}
                              >
                                {keyEmptyCheck(step.key)}
                              </StepLabel>
                            </StepButton>
                            {index === currentStep && (
                              <ADGMImage name='active_icon.svg' alt='Active Step' /> // active-step
                            )}
                            {currentStep > index && (
                              <ADGMImage name='completed_icon.svg' alt='Completed Step' /> // completed-step
                            )}
                            {currentStep < index && (
                              <ADGMImage name='steps_icon.svg' alt='Remaining Steps' /> // remaining-step
                            )}
                          </Step>
                        ))}
                    </Stepper>
                  </div>
                </Grid>
                <Grid item xs={2} md={2} style={{ order: isMobile ? 1 : 2 }} className={classes.countBlock}>
                  {!loading && (
                    <Typography className={classes.stepsCount}>
                      {currentStep + 1} / {steps?.filter(step => step.groupKey)?.length}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </div>
            <Grid item xs={12} md={9}>
              <div className={classes.panels}>
                {/* for only lease registration and multiple units */}
                {currentStep === 1 && isMultipleUnits && (
                  <LeaseUnitDetails
                    workflow={workflow}
                    currentStep={currentStep}
                    handleChange={handleFormChange}
                    onwaniAddress={onwaniAddress}
                    applicationNumber={applicationNumber}
                    isMultipleUnits={isMultipleUnits}
                    intl={intl}
                    loading={loading}
                    isRegistration={isRegistration}
                    {...otherProps}
                  />
                )}
                {panels
                  .filter(item =>
                    isLeaseApp ? item?.key === leaseSteps?.[currentStep]?.key : item?.key === steps[currentStep]?.key,
                  )
                  .map((panel, index) => {
                    const Component = panelComponents?.[panel.name];
                    return Component ? (
                      <>
                        <Component
                          key={panel.id}
                          intl={intl}
                          panel={panel}
                          attributes={attributes.filter(atr => atr.panelName === panel.name)}
                          loading={loading}
                          workflow={workflow}
                          currentStep={currentStep}
                          handleChange={handleFormChange}
                          getWorkflowDropdownValue={getWorkflowDropdownValue}
                          getMask={getFieldMask}
                          onwaniAddress={onwaniAddress}
                          applicationNumber={applicationNumber}
                          isMultipleUnits={isMultipleUnits}
                          isRegistration={isRegistration}
                          {...otherProps}
                        />
                        {panel.key === 'REVIEW' && panel.name === 'tenantInformation' && (
                          <PrimaryLessorInformation
                            key={`${panel.id + index}`}
                            panel={panel}
                            application={otherProps.application}
                          />
                        )}
                      </>
                    ) : (
                      <p key={panel.id} style={{ order: panel.order }}>
                        Panel name ({panel.name}) has been changed/removed from the API
                      </p>
                    );
                  })}
              </div>

              {/* Cancel Modal */}
              <CancelApplicationModal
                open={dialogueOpen}
                onClose={() => setDialogueOpen(false)}
                cancelApplication={() => (callCancelApi ? cancelApplication() : handleBack())}
              />
            </Grid>
          </>
        ) : (
          <Grid xs={12}>
            <Button
              variant='contained'
              className={classes.gotoproBtn}
              onClick={() => history.push('/app/applications')}
            >
              <FormattedMessage {...messages.go_to_applications} />
            </Button>
          </Grid>
        )}
        {!isEmpty(workflow) && (
          <Grid container className={classes.footerClass}>
            <Grid container className={classes.outerFooterContainer}>
              <Grid xs={12} md={9} className={classes.footerContainer}>
                <div className={classes.navigatorContainer}>
                  <Button
                    disabled={
                      loading || !workflow?.steps || (currentStep === 0 && otherProps?.applicationStatus === 'DRAFT')
                    }
                    onClick={handleDialogue}
                    className={classNames(classes.backButton, otherProps.locale === 'ar' && classes.rotateArrow)}
                  >
                    <ADGMImage
                      name={
                        loading || (currentStep === 0 && otherProps?.applicationStatus === 'DRAFT')
                          ? 'previousIcon.svg'
                          : 'PreviousArrow.png'
                      }
                      alt='prevIcon'
                    />
                    <FormattedMessage {...messages.previous} />
                  </Button>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleNext}
                    className={classNames(classes.nextButton, otherProps.locale === 'ar' && classes.rotateArrow)}
                    disabled={loading}
                  >
                    {isLastStep() || isLastLeaseStep ? (
                      <FormattedMessage {...messages.submit} />
                    ) : (
                      <FormattedMessage {...messages.next} />
                    )}
                    <ADGMImage name={loading ? 'nextArrow_black.svg' : 'NextArrow.png'} alt='nextIcon' />
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
}

ADGMWorkflow.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  panelComponents: PropTypes.object.isRequired,
  workflow: PropTypes.object,
  currentStep: PropTypes.number,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  cancelApplication: PropTypes.func.isRequired,
  onwaniAddress: PropTypes.array,
  applicationNumber: PropTypes.string.isRequired,
  handleDialogueCancel: PropTypes.func,
  openDialogueCancel: PropTypes.bool,
  isMultipleUnits: PropTypes.bool,
  isRegistration: PropTypes.bool,
  workflowId: PropTypes.string,
  isPermission: PropTypes.bool,
};

ADGMWorkflow.defaultProps = {
  workflow: {},
  currentStep: 0,
  onwaniAddress: [],
  handleDialogueCancel: () => {},
  openDialogueCancel: false,
  isMultipleUnits: false,
  isRegistration: false,
  workflowId: null,
  isPermission: false,
};

export default injectIntl(withStyles(styles)(ADGMWorkflow));
